import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionTracker } from '../components/collectes/CollectionTracker';
import { CollectionList } from '../components/collectes/CollectionList';
import { ReminderPreferences } from '../components/collectes/ReminderPreferences';
export function MesCollectes() {
  const [remindersOpen, setRemindersOpen] = useState(false);
  return <main className="bg-white" data-id="element-2942" data-mp="3q4gs2jfjmk4z">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2943" data-mp="3q5a15r1z5lqa">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2944" data-mp="3u4981h79nskd">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-2945" data-mp="300w82vl4gwp">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2946" data-mp="7v7vmyhtmzft" />
          <span aria-current="page" data-id="element-2947" data-mp="83ocpvhrt3k8">Mes collectes</span>
        </nav>

        <header className="mt-4" data-id="element-2948" data-mp="32qvpm8hyfkb">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2949" data-mp="31p8yki4c4mr">
            <Link to="/mes-collectes/calendrier" className="group inline-flex items-center gap-2 rounded transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2950" data-mp="3v7clxqq40jed">
              Mes collectes
              <ChevronRightIcon className="h-7 w-7 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo lg:h-8 lg:w-8" aria-hidden="true" data-id="element-2951" data-mp="mt41j5xqqyxa" />
              <span className="sr-only" data-id="element-2952" data-mp="1ahn9tlgsjbpd">Voir le calendrier complet</span>
            </Link>
          </h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-2953" data-mp="15p3lpukh8y6b">
            Consultez vos prochaines collectes et obtenez rapidement l’information pour votre adresse.
          </p>
        </header>

        <div className="mt-8" data-id="element-2954" data-mp="1tkp17q1br7kg">
          <AtnaAssistant data-id="element-2955" data-mp="1ftseugxzrmlu" />
        </div>

        <div className="mt-6" data-id="element-2956" data-mp="1fsr3scgz7044">
          <AddressCard data-id="element-2957" data-mp="1ftk2cq5s6jb6" />
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[380px_minmax(0,1fr)] lg:gap-8" data-id="element-2958" data-mp="1jv5m8vgqfxuv">
          <CollectionTracker remindersOpen={remindersOpen} onToggleReminders={() => setRemindersOpen(current => !current)} data-id="element-2959" data-mp="15vme42nx8mik" />
          <div className="flex min-w-0 flex-col" data-id="element-2960" data-mp="1awabr76no1lr">
            <CollectionList data-id="element-2961" data-mp="wvg3qpnis2nm" />
            <AnimatePresence data-id="element-2962" data-mp="ww9e00lotaai">
              {remindersOpen && <ReminderPreferences key="reminder-preferences" onClose={() => setRemindersOpen(false)} data-id="element-2963" data-mp="10w9v5t067zl9" />}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </main>;
}